import { createReducer } from "@reduxjs/toolkit";
import translation from "../../locales/messages";
import { DEFAULT_LOCALE, flattenMessages } from "../../locales/utils";

export const generateInitialState = () => ({
  locale:
    window.translations && window.translations[navigator.language.split("-")[0]]
      ? navigator.language.split("-")[0]
      : DEFAULT_LOCALE,
  messages: window.translations
    ? window.translations[navigator.language.split("-")[0]] ||
      window.translations[DEFAULT_LOCALE]
    : flattenMessages(translation[DEFAULT_LOCALE]),
  languages: window.translations ? Object.keys(window.translations) : ["en"],
});

//breaking the generation of the initial state into it's own method so we can unit test it better.
export const initialState = generateInitialState();

const reducer = createReducer(initialState, {});

export default reducer;
